import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { CompanyState } from "./types";
import CompanyService from "@/services/company.service";
import { BaseAdmin } from "@/services/bases/base.service";
const service: CompanyService = new CompanyService();

export const actions: ActionTree<CompanyState, RootState> = {
    getMasterJobs({ state }, cb: Partial<ActionCallback>) {
        service.getMasterJobs(cb?.params).then(({ data: { data } }) => state.masterJobs = data).catch(() => undefined)
    },
    getNotification(_, params) {
        return BaseAdmin().get("admin-job-fair/landing/company/notification/get", params);
    },
};
